<template>
  <b-modal v-model="show" centered :title="title"
  >
    <b-row>
      <b-col>
        <label >Tourname:</label>
        <b-row style="margin-bottom: 1rem">
          <b-col>
            <b-form-input class="form-control"
                          :style="listName === '' ? 'border-color: red;' : 'color: black;'"
                          v-model="listName"
                          ></b-form-input>
          </b-col>
        </b-row>
        <b-form-group
            label="Zieldatum"
            label-for="end-date"
        >
          <datetime
              style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
              v-model="zielDate"
              input-class="form-control"
              :input-style="zielDate === null || zielDate === '' ? 'border-color: red;' : 'color: black;'"
              input-id="end-date"
              :aria-placeholder="formateDate"
              :phrases="datetimeConfig.phrases"
              :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
              :min-datetime="datetimeConfig.minTime"></datetime>
        </b-form-group>
        <label >Zuweisung:</label>
        <b-row>
          <b-col>
            <b-form-input class="form-control"
                          :style="defaultAllocationText === '' ? 'border-color: red;' : 'color: black;'"
                          v-model="defaultAllocationText"
                          disabled @click="$refs.select_default_planning_dialog.showDialog(defaultAllocation)"></b-form-input>
          </b-col>
          <b-col md="1" style="padding-left: 0px; padding-top: 5px">
            <edit-icon title="" v-tooltip="'Anpassen'" class="icon-1_5x" fillColor="#2463ea" style=" cursor: pointer; color: #016d03; margin-left: 4px;margin-bottom: 2px;" :size="72" @click="$refs.select_default_planning_dialog.showDialog(defaultAllocation)"></edit-icon>
          </b-col>
        </b-row>
      </b-col>
      <select-default-planning-dialog ref="select_default_planning_dialog" @default-selected="onDefaultSelected" />
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" variant="success" @click="onSave" :disabled="!canContinue">
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>

import {DateTime as LuxonDateTime} from "luxon";
import SelectDefaultPlanningDialog from "@/views/aufgaben_verwaltung/SelectDefaultPlanningDialog.vue";
import EditIcon from 'vue-material-design-icons/PencilCircle.vue';

export default {
  name: "PrintListDialog",
  components: {SelectDefaultPlanningDialog, EditIcon},
  props:{
    taskDate: {
      type: String,
      default: () => new Date().toISOString()
    },
  },
  data() {
    return {
      zielDate: null,
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
      defaultAllocation: "",
      defaultAllocationText: "",
      listName: '',
      show: false,
      error: false,
      title: 'Tour anlegen',
    }
  },
  computed: {
    formateDate() {
      if (this.zielDate === null) {
        return ""
      }
      let event = new Date(this.zielDate.replace('Z', ''));
      let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return event.toLocaleDateString('de-DE', options);
    },
    canContinue() {
      return this.zielDate !== null && this.zielDate !== '' && this.defaultAllocation !== '' && this.listName !== '';
    },
  },
  methods: {
    onDefaultSelected(def) {
      this.defaultAllocationText = def.map((list) => list.name).join(", ")
      this.defaultAllocation = def.map((list) => list.id).join(",")
    },
    showModal(structure) {
      this.zielDate = null;
      this.defaultAllocation = "";
      this.defaultAllocationText = "";
      this.listName = "";
      this.error = false;
      this.show = true;
      this.$nextTick(() => {
        let data = JSON.parse(JSON.stringify(structure));
        this.computeMitas(data);
        this.$refs.select_default_planning_dialog.init(data);
      })
    },
    showModalPreset(structure, zielDate, defaultAllocation, defaultAllocationText, listName) {
      this.title = "Anpassen";
      this.zielDate = zielDate;
      this.defaultAllocation = defaultAllocation;
      this.defaultAllocationText = defaultAllocationText;
      this.listName = listName;
      this.error = false;
      this.show = true;
      this.$nextTick(() => {
        let data = JSON.parse(JSON.stringify(structure));
        this.computeMitas(data);
        this.$refs.select_default_planning_dialog.init(data);
      })
    },
    computeMitas(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type === "user") {
          let cur = {...data[i]}
          let parsed = JSON.parse(sessionStorage.getItem(cur.id));
          if (parsed) {
            cur.text = parsed.full_name;
          }
          data[i] = cur;
        } else {
          this.computeMitas(data[i].children)
        }
      }
      data.sort((a,b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
    },
    getReturnData() {
      let res = {
        default_allocation: this.defaultAllocation,
        ziel_date: this.zielDate,
        list_name: this.listName
      };
      return res;
    },
    async onSave() {
      let data = this.getReturnData();
      this.$emit('create-list-planning', data);
      this.show = false;
    },

    onCancel() {
      this.show = false;
    },
  }
}
</script>

<style scoped>
.text-black {
  color: black;
}
.vld-overlay.is-full-page {
  z-index: 1600;
  position: fixed;
}
.label-horizontal {
  display: inline-flex;
  align-items: center;
  height: 35px;
}

::v-deep .custom-checkbox {
  min-width: 94px;
}

</style>
